import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { APP_ROUTES, SIDEBAR_GROUPS } from '../routes/config';
import { isClassificationEnabled as isRouteClassificationEnabled } from '../utils/routeAccess';

export const useSidebarMenus = (userRole) => {
  const userInfo = useSelector((state) => state.auth?.userInfo);
  const clientConfig = userInfo?.client_config;

  return useMemo(() => {
    const isClassificationEnabled = (route) =>
      isRouteClassificationEnabled(route, { clientConfig, userRole });

    const routeMenus = APP_ROUTES.filter((route) => {
      if (!route.sidebarGroup || !route.roles.includes(userRole)) return false;
      return isClassificationEnabled(route);
    });
    const groupedMenus = routeMenus.reduce((acc, route) => {
      const group = route.sidebarGroup;
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push({
        label: route.sidebarLabel,
        path: route.path,
        icon: route.sidebarIcon,
        icon_color: route.sidebarIconColor,
        priority: route.priority,
      });
      return acc;
    }, {});
    const standaloneMenus = APP_ROUTES.filter((route) => {
      if (
        !route.roles.includes(userRole) ||
        !route.sidebarLabel ||
        route.sidebarGroup
      )
        return false;
      return isClassificationEnabled(route);
    }).reduce((acc, route) => {
      const key = route.sidebarKey || route.path;
      if (!acc[key]) {
        acc[key] = {
          label: route.sidebarLabel,
          path: route.path,
          icon: route.sidebarIcon,
          icon_color: route.sidebarIconColor,
          priority: route.priority,
        };
      }
      return acc;
    }, {});
    const mainLogos = SIDEBAR_GROUPS.flatMap((group) => {
      const subMenus = groupedMenus[group.sidebarGroup];
      return subMenus?.length ? [{ ...group, subMenus }] : [];
    });
    return [...mainLogos, ...Object.values(standaloneMenus)].sort(
      (a, b) => a.priority - b.priority,
    );
  }, [userRole, clientConfig]);
};
